/**
 * Ordem "natural" de descricao de produto: o numero dentro do nome e' comparado como NUMERO.
 *
 * Alfabetico puro compara digito a digito, entao 'FLEX 10MM' vem antes de 'FLEX 1MM' e a lixa
 * sai 120, 150, 220, 36, 50, 80. Pedido do Ruan (06/10/2026): ordenar a Lista de Produtos pela
 * descricao "do menor para o maior" pra descer a coluna de preco de uma familia em sequencia.
 *
 * A virgula decimal faz parte do numero ('1,5MM' = 1.5), que e' como a loja escreve bitola.
 */
const PEDACO = /(\d+(?:,\d+)?)|(\D+)/g;

function pedacos(texto: string): Array<number | string> {
  const out: Array<number | string> = [];
  for (const m of texto.matchAll(PEDACO)) {
    out.push(m[1] !== undefined ? Number(m[1].replace(',', '.')) : m[2]!);
  }
  return out;
}

export function compararDescricaoNatural(a: string | null | undefined, b: string | null | undefined): number {
  const pa = pedacos((a ?? '').trim().toUpperCase());
  const pb = pedacos((b ?? '').trim().toUpperCase());
  const n = Math.min(pa.length, pb.length);
  for (let i = 0; i < n; i++) {
    const x = pa[i]!;
    const y = pb[i]!;
    if (typeof x === 'number' && typeof y === 'number') {
      if (x !== y) return x - y;
    } else if (typeof x === 'number') {
      return -1; // numero antes de texto, como no alfabetico
    } else if (typeof y === 'number') {
      return 1;
    } else {
      const c = x.localeCompare(y, 'pt-BR', { sensitivity: 'base' });
      if (c !== 0) return c;
    }
  }
  return pa.length - pb.length;
}
